import type { UserSurveyData } from './user-survey';
import type { Loan } from '@/types/nsldsTypes';

// US states for dropdown
export const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'GU', label: 'Guam' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VI', label: 'Virgin Islands' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
  { value: 'DC', label: 'District of Columbia' },
];

// Define test cases for debugging
export const DEBUG_TEST_CASES: Array<{
  label: string;
  value: UserSurveyData;
  userManualLoanData?: Loan;
  partnerManualLoanData?: Loan;
}> = [
  {
    label: 'Single, Medium Income, MD, No PSLF',
    value: {
      annualIncome: 130000,
      includePartner: false,
      partnerAnnualIncome: null,
      familySize: 1,
      state: 'MD',
      pslfEligible: true,
      pslfEligiblePartner: false,
      appointmentMade: false,
      filingStatus: 'Single',
    },
  },
  {
    label: 'Single, Low Income, CA, PSLF',
    value: {
      annualIncome: 30000,
      includePartner: false,
      partnerAnnualIncome: null,
      familySize: 1,
      state: 'CA',
      pslfEligible: true,
      pslfEligiblePartner: false,
      appointmentMade: false,
      filingStatus: 'Single',
    },
  },
  {
    label: 'Married, High Income, TX, No PSLF, MFJ',
    value: {
      annualIncome: 150000,
      includePartner: true,
      partnerAnnualIncome: 120000,
      familySize: 4,
      state: 'TX',
      pslfEligible: false,
      pslfEligiblePartner: false,
      appointmentMade: false,
      filingStatus: 'MFJ',
    },
  },
  {
    label: 'Partner, Mid Income, NY, 3 kids, Both PSLF, MFS',
    value: {
      annualIncome: 80000,
      includePartner: true,
      partnerAnnualIncome: 60000,
      familySize: 5,
      state: 'NY',
      pslfEligible: true,
      pslfEligiblePartner: true,
      appointmentMade: true,
      filingStatus: 'MFS',
    },
  },
  {
    label: 'Single, No Income, FL',
    value: {
      annualIncome: 0,
      includePartner: false,
      partnerAnnualIncome: null,
      familySize: 1,
      state: 'FL',
      pslfEligible: false,
      pslfEligiblePartner: false,
      appointmentMade: false,
      filingStatus: 'Single',
    },
  },
  {
    label: 'Single, Manual Loan Example',
    value: {
      annualIncome: 75000,
      includePartner: false,
      partnerAnnualIncome: null,
      familySize: 1,
      state: 'CO',
      pslfEligible: false,
      pslfEligiblePartner: false,
      appointmentMade: false,
      filingStatus: 'Single',
    },
    userManualLoanData: {
      'Loan Award ID': 'USER_MANUAL_DEBUG_01',
      Borrower: 'user',
      'Total Outstanding': 50000,
      'Outstanding Principal': 50000,
      'Outstanding Interest': 0,
      'Loan Interest Rate': 0.068,
      'Loan Type Group': 'Direct',
      'Current Loan Status Description': 'In Repayment',
      'Loan PSLF Cumulative Matched Months': 0,
      qualifiedPaymentMonths: 0,
      isInRepayment: true,
      originalPrincipal: 50000,
      degreeType: 'graduate',
    } as Loan,
  },
];
